import React, { useEffect, useRef, useState } from "react";

import SectionNumber from "../global/SectionNumber";
import SmartColour from "../../utils/ColourHandler";
import SmartText from "../../utils/TextHandler";
import SmartStyles from "../../utils/StyleHandler";
import Job from "../instances/Job";
import Share from "../global/Share";
import Dropdown from "../global/forms/Dropdown";

const Jobs = ({ blok }) => {
  const { copy, ctas, number, padding, rounded, subtitle, theme, title } = blok;

  const colour = SmartColour(theme);

  function makeIdSafe(str) {
    if (!str) {
      return;
    }
    str = str.replace(/\s+/g, "-").toLowerCase();
    return "department-" + str;
  }

  const [shareData, setShareUrl] = useState(false);

  const selectedDept =
    typeof window !== "undefined"
      ? sessionStorage.getItem("dept") || "all"
      : "all";

  const shareHandler = (shareData) => {
    setShareUrl(shareData);
  };

  const [allJobs, setAllJobs] = useState(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const workable = JSON.parse(sessionStorage.getItem("workable"));

      if (workable?.jobs) {
        console.log("Reusing data");

        // Use the existing data
        setAllJobs(workable.jobs);
      } else {
        // Go get the data
        fetch(
          `https://apply.workable.com/api/v1/widget/accounts/lighthousegames?details=true`
        )
          .then((response) => response.json()) // parse JSON from request
          .then((resultData) => {
            let jobs = resultData.jobs;
            jobs.sort(function (a, b) {
              if (a.department && b.department) {
                return a.department.localeCompare(b.department);
              }
            });
            console.log("Getting new data: ");

            sessionStorage?.setItem("workable", JSON.stringify(resultData));
            setAllJobs(jobs);
          });
      }
    }
  }, []);

  const allJobsDepartmentTitle = [];

  const selectRef = useRef(null);

  const [departmentData, filterDepartment] = useState(selectedDept);

  const [filterValue, setFilterValue] = useState(selectedDept);

  const sortOptions = [
    { label: "All departments", value: "all" },
    { label: "Art", value: "art" },
    { label: "Animation", value: "animation" },
    { label: "Design", value: "design" },
    { label: "Game Engineering", value: "game-engineering" },
    { label: "Operations", value: "operations" },
    { label: "Production", value: "production" },
    { label: "Speculative", value: "speculative" },
  ];

  const processedDepartments = [{ label: "All Departments", value: "all" }]; // Make sure it's an array
  const seenDepartments = new Set();

  allJobs &&
    allJobs.forEach((item) => {
      if (item.department && !seenDepartments.has(item.department)) {
        const safeID = item.department
          .toLowerCase()
          .replace(/\s+/g, "-") // Replace spaces with hyphens
          .replace(/[^a-z0-9-]/g, ""); // Remove special characters

        processedDepartments.push({
          label: item.department,
          value: safeID,
        });

        seenDepartments.add(item.department);
      }
    });

  const handleDropdown = (value) => {
    filterDepartment(value);
    setFilterValue(value);
    if (typeof window !== "undefined") {
      sessionStorage.setItem("dept", value);
    }
  };

  if (!blok) return null; // Escape hatch

  return (
    <>
      <section
        className={`flex flex-col ${
          colour.classes && colour.classes
        } ${SmartStyles("padding", padding)} ${SmartStyles(
          "rounded",
          rounded
        )}`}
        id="roles"
      >
        <div className="brand-container flex flex-col gap-10 md:gap-12 min-h-[100vh]">
          <SectionNumber
            title={subtitle && subtitle}
            number={number && number}
          />
          {title && <h1 className="m-0 text-center">{title}</h1>}
          {copy?.content[0]?.content && (
            <SmartText className="m-0 text-center brand-remove-last-margin">
              {copy}
            </SmartText>
          )}
          <div>
            <div className="w-full md:w-1/3 md:ms-auto mb-6">
              <Dropdown
                placeholder="Filter by department"
                namespace="department_select"
                value={filterValue}
                ref={selectRef}
                onChange={handleDropdown}
                options={processedDepartments}
              />
            </div>

            {allJobs ? (
              allJobs.map((item) => {
                const dept = item.department || "Central";
                const thisDept = makeIdSafe(dept);
                if (allJobsDepartmentTitle.includes(dept)) {
                  item.departmentTitle = null;
                } else {
                  item.departmentTitle = dept;
                  allJobsDepartmentTitle.push(dept);
                }
                if (makeIdSafe(departmentData) !== "department-all") {
                  if (thisDept !== makeIdSafe(departmentData)) {
                    // Only do this check if the dep filter is set
                    return;
                  }
                }

                return <Job data={item} shareHandler={shareHandler} />;
              })
            ) : (
              <p className="text-center text-black scale-150">
                <span className="material-icons animate-spin">autorenew</span>
              </p>
            )}
          </div>
        </div>
      </section>
      {shareData ? (
        <>
          <Share data={shareData} shareHandler={shareHandler} />
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default Jobs;
